<template>
    <div id="app" class="app">
        <router-view />
    </div>
</template>
<script>
// @ is an alias to /src
export default {
    methods: {
        createPageTitle: function (to) {
            // タイトルを設定
            if (to.meta.title) {
                var setTitle = to.meta.title
                document.title = setTitle
            }
        },
    },
    mounted: function () {
        var to = this.$route
        this.createPageTitle(to)
    },
    watch: {
        $route(to) {
            this.createPageTitle(to)
        },
    },
}
</script>
<style>
html,
body,
.app {
    height: 100%;
}

body > #app {
    height: auto;
}
</style>
